export class Messages {
  // Error Messages
  public static readonly UNEXPECTED_ERROR = "Si è verificato un errore imprevisto.";
  public static readonly NO_INTERNET_CONNECTION = "Nessuna connessione internet rilevata.";
  public static readonly SERVER_UNREACHABLE = "Impossibile contattare il server. Riprova più tardi.";
  public static readonly SESSION_EXPIRED = "Sessione scaduta o non valida. Effettua nuovamente il login.";
  public static readonly SERVER_INTERNAL_ERROR = "Errore interno del server. Riprova più tardi.";
  public static readonly LOGIN_ERROR = "Credenziali non valide. Riprova.";
  public static readonly REGISTRATION_ERROR = "Errore durante la registrazione";
  public static readonly REGISTRATION_CONFIRM_EMAIL = "Registrazione completata: controlla la tua email e conferma l'account prima del login.";
  public static readonly USER_NOT_ACTIVE = "Utente non attivo, conferma la tua email per attivare il tuo account";
  public static readonly USER_DATA_NOT_FOUND = "Dati utente non trovati.";
  public static readonly TABLE_LOAD_ERROR = "Errore nel caricamento del tavolo";
  public static readonly LOGIN_REQUIRED = "Per utilizzare questa funzione è richiesto l'accesso";
  public static readonly TABLE_DELETE_ERROR = "Errore durante l'eliminazione del tavolo";
  public static readonly TABLE_PARTICIPATION_ERROR = "Errore durante la partecipazione al tavolo";
  public static readonly TABLE_PARTICIPATION_REMOVE_ERROR = "Errore durante l'eliminazione della partecipazione al tavolo";
  public static readonly ASSOCIATION_ONLY = "Solo le associazioni possono accedere a questa funzionalità";
  public static readonly ADMIN_ONLY = "Solo gli amministratori possono accedere a questa funzionalità";
  public static readonly ASSOCIATION_OR_ADMIN_ONLY = "Solo le associazioni e gli amministratori possono accedere a questa funzionalità";
  public static readonly ORGANIZATION_CONTENT_CREATE_ONLY =
    "Per creare eventi o tavoli devi appartenere a un'organizzazione e avere i permessi necessari";
  public static readonly ORGANIZATION_MANAGER_ONLY =
    "Solo i gestori dell'organizzazione possono accedere a questa funzionalità";
  public static readonly FORBIDDEN = "Non hai i permessi per eseguire questa azione";
  public static readonly EVENT_LOAD_ERROR = "Errore nel caricamento dell'evento";
  public static readonly EVENT_SAVE_ERROR = "Errore durante il salvataggio dell'evento";
  public static readonly EVENT_DELETE_ERROR = "Errore durante l'eliminazione dell'evento";
  public static readonly EVENT_CREATED_SUCCESS = "Evento creato con successo";
  public static readonly EVENT_UPDATED_SUCCESS = "Evento aggiornato con successo";
  public static readonly EVENT_NOT_FOUND = "Evento non trovato";
  public static readonly EVENT_DELETE_SUCCESS: string = "Evento eliminato con successo";
  public static readonly EVENT_INVITED_ORG_ADD_SUCCESS = "Organizzazione invitata aggiunta con successo";
  public static readonly EVENT_INVITED_ORG_ADD_ERROR = "Errore durante l'aggiunta dell'organizzazione invitata";
  public static readonly EVENT_INVITED_ORG_REMOVE_SUCCESS = "Organizzazione invitata rimossa con successo";
  public static readonly EVENT_INVITED_ORG_REMOVE_ERROR = "Errore durante la rimozione dell'organizzazione invitata";
  public static readonly SESSION_SAVE_ERROR = "Errore durante il salvataggio della sessione";
  public static readonly TABLE_NOT_FOUND: string = "Tavolo non trovato";

  // Success Messages
  public static readonly TABLE_CREATED_SUCCESS = "Tavolo creato con successo!";
  public static readonly TABLE_UPDATED_SUCCESS = "Tavolo aggiornato con successo!";
  public static readonly TABLE_SAVE_ERROR = "Errore durante il salvataggio del tavolo";
  public static readonly TABLE_DELETED_SUCCESS = "Tavolo eliminato con successo!";
  public static readonly GAME_CREATED_SUCCESS = "Gioco creato con successo!";
  public static readonly GAME_UPDATED_SUCCESS = "Gioco aggiornato con successo";
  public static readonly GAME_ASSOCIATED_SUCCESS = "Gioco associato con successo"
  public static readonly TABLE_PARTICIPATION_SUCCESS = "La tua partecipazione è stata registrata con successo";
  public static readonly SESSION_CREATED_SUCCESS = "Sessione creata con successo";
  public static readonly ORGANIZATION_UPDATED_SUCCESS: string = "Organizzazione aggiornata con successo";
  public static readonly ORGANIZATION_CREATED_SUCCESS: string = "Organizzazione creata con successo";
  public static readonly ORGANIZATION_DELETED_SUCCESS: string = "Organizzazione eliminata con successo";

  // Confirm dialog
  public static readonly CONFIRM_TITLE = "Conferma";
  public static readonly CONFIRM_ACCEPT = "Conferma";
  public static readonly CONFIRM_CANCEL = "Annulla";
  public static readonly CONFIRM_DELETE = "Elimina";
  public static readonly CONFIRM_REMOVE = "Rimuovi";
  public static readonly CONFIRM_ORGANIZATION_DELETE_TITLE = "Elimina organizzazione";
  public static readonly CONFIRM_MEMBER_REMOVE_TITLE = "Rimuovi membro";
  public static readonly CONFIRM_EVENT_DELETE_TITLE = "Elimina evento";
  public static readonly CONFIRM_TABLE_DELETE_TITLE = "Elimina tavolo";
  public static readonly CONFIRM_SESSION_DELETE_TITLE = "Elimina sessione";
  public static readonly CONFIRM_GAME_DELETE_TITLE = "Elimina gioco";
  public static readonly CONFIRM_PARTICIPATION_REMOVE_TITLE = "Lascia tavolo";
  public static readonly CONFIRM_SESSION_DELETE = "Sei sicuro di voler eliminare questa sessione?";
  public static readonly CONFIRM_PARTICIPATION_REMOVE = "Vuoi togliere questa partecipazione dal tavolo?";

  public static confirmOrganizationDelete(name: string): string {
    return `Sei sicuro di voler eliminare l'organizzazione "${name}"?`;
  }

  public static confirmMemberRemove(userName: string | undefined, userId: number): string {
    return `Vuoi rimuovere "${userName || 'Utente #' + userId}" dall'organizzazione?`;
  }

  public static confirmEventDelete(name: string): string {
    return `Sei sicuro di voler eliminare l'evento "${name}"?`;
  }

  public static confirmInvitedOrganizationRemove(name: string): string {
    return `Sei sicuro di voler rimuovere "${name}" dalle organizzazioni invitate?`;
  }

  public static confirmTableDelete(name: string): string {
    return `Sei sicuro di voler eliminare il tavolo "${name}"?`;
  }

  public static readonly CONFIRM_USER_DELETE_TITLE = "Elimina utente";
  public static readonly USER_DELETED_SUCCESS = "Utente eliminato con successo";
  public static readonly USER_UPDATED_SUCCESS = "Utente aggiornato con successo";
  public static readonly USER_ACTIVATION_SUCCESS = "Utenza attivata con successo";
  public static readonly USER_DEACTIVATION_SUCCESS = "Utenza disattivata con successo";
  public static readonly CONFIRM_USER_ACTIVATION_TITLE = "Attiva utente";
  public static readonly CONFIRM_USER_FORCE_ACTIVATION_TITLE = "Forza attivazione utente";
  public static readonly CONFIRM_USER_DEACTIVATION_TITLE = "Disattiva utente";
  public static confirmUserActivation(name: string): string {
    return `Vuoi attivare l'account dell'utente "${name}"?`;
  }
  public static confirmUserForceActivation(name: string): string {
    return `L'utente "${name}" è in attesa di conferma email. Vuoi forzare l'attivazione dell'account?`;
  }
  public static confirmUserDeactivation(name: string): string {
    return `Vuoi disattivare l'account dell'utente "${name}"? L'utente non potrà più accedere fino a una nuova attivazione.`;
  }
  public static confirmUserDelete(name: string): string {
    return `Vuoi eliminare l'utente ${name}? L'account verra' disattivato.`;
  }
  public static confirmGameDelete(name: string): string {
    return `Sei sicuro di voler eliminare "${name}"?`;
  }
}





